// app/providers.tsx
"use client";
import React, { useEffect } from "react";

// PHProvider lazily loads posthog-js during idle time and stores the client
// on window.__posthog. Consumers use the custom usePostHog hook (lib/hooks/usePostHog)
// instead of posthog-js/react, keeping posthog-js/react out of the shared bundle.
export function PHProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    if (typeof window === "undefined") return;

    let cancelled = false;

    const doInit = async () => {
      try {
        const { default: posthog } = await import("posthog-js");
        if (cancelled) return;
        posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
          api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
          person_profiles: "identified_only",
          capture_pageview: false,
          capture_pageleave: true,
        });
        if (!cancelled) {
          (window as any).__posthog = posthog;
          window.dispatchEvent(new Event("posthog:ready"));
        }
      } catch (e) {
        // swallow - analytics shouldn't break the app
        // eslint-disable-next-line no-console
        console.warn("PostHog failed to load:", e);
      }
    };

    if ((window as any).requestIdleCallback) {
      (window as any).requestIdleCallback(() => doInit(), { timeout: 2000 });
    } else {
      setTimeout(() => doInit(), 2000);
    }

    return () => {
      cancelled = true;
    };
  }, []);

  return <>{children}</>;
}
